import type { LoaderFunctionArgs } from "react-router";

import { APP_CONFIG_QUERY_KEY } from "~/features/permissions/AbilityContext";
import { useRootData } from "~/hooks/use-root-data";
import { fetchJson } from "~/utils/fetch-json";

import { useQuery } from "@tanstack/react-query";
import type { Jsonify } from "type-fest";

export type AppConfigData = Jsonify<Awaited<ReturnType<typeof loader>>>;

export async function loader({ context }: LoaderFunctionArgs) {
  return context.appConfig;
}

export const useAppConfig = () => {
  const rootData = useRootData();

  const queryFn = () => fetchJson<AppConfigData>("/api/app-config");

  const sync = rootData?.appConfig?.syncAppConfig;

  return useQuery({
    enabled: sync?.enabled,
    queryKey: [APP_CONFIG_QUERY_KEY, sync?.intervalMs],
    queryFn,
    refetchInterval: sync?.intervalMs,
    refetchIntervalInBackground: true,
    initialData: rootData?.appConfig,
  });
};
